import React, { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import { compose } from "redux";
import cx from "classnames";
import _ from "lodash";

import userImg from "assets/images/users.png";
import HalfLemon from "assets/images/halfLemon.png";
import fullLemon from "assets/images/fullLemon.png";
import AllActivity from "assets/images/allactivity.png";
import TeamBlander from "assets/images/teamblender.png";
import useWindowSize from "components/shared/WindowResize";
import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";
import * as socketAction from "redux/sockets/action";

const TeamAct = ({ browseActivity, ...props }) => {
  const { width } = useWindowSize();

  const slices = _.get(browseActivity, "slices", []);
  const squeezes = _.get(browseActivity, "squeezes", []);
  const team_blenders = _.get(browseActivity, "team_blenders", []);
  const [activityType, setActivityType] = useState("All Activities");
  const [categoryType, setCategoryType] = useState([]);
  const [seeMoreTextSqueezes, setSeeMoreTextSqueezes] = useState("See More");
  const [seeMoreTextSlices, setSeeMoreTextSlices] = useState("See More");
  const [seeMoreTextTeamBlenders, setSeeMoreTextTeamBlenders] =
    useState("See More");
  const [seeMoreSqueezes, setSeeMoreSqueezes] = useState(2);
  const [seeMoreSlices, setSeeMoreSlices] = useState(2);
  const [seeMoreTeamBlenders, setSeeMoreTeamBlenders] = useState(2);
  const gameCategories = _.get(browseActivity, "categories", ["Cooperative"]);

  const ACTIVITY_TYPES = {
    ALL: "All Activities",
    SQUEEZE: "Squeeze: 3-5 mins",
    SLICE: "Slice: 15-30 mins",
    TEAM_BLENDER: "Team Blender: +60 mins"
  };
  const handleSeeMoreSqueezes = () => {
    if (seeMoreTextSqueezes === "See More") {
      setSeeMoreTextSqueezes("See Less");
    } else {
      setSeeMoreTextSqueezes("See More");
    }
    if (seeMoreSqueezes === 2) {
      setSeeMoreSqueezes(10);
    } else {
      setSeeMoreSqueezes(2);
    }
  };
  const handleBlenderClick = (e) => {
    window.location.href = "https://heylime.com/events";
  };
  const handleSeeMoreSlices = () => {
    if (seeMoreTextSlices === "See More") {
      setSeeMoreTextSlices("See Less");
    } else {
      setSeeMoreTextSlices("See More");
    }
    if (seeMoreSlices === 2) {
      setSeeMoreSlices(11);
    } else {
      setSeeMoreSlices(2);
    }
  };
  const handleSeeMoreTeamBlenders = () => {
    if (seeMoreTextTeamBlenders === "See More") {
      setSeeMoreTextTeamBlenders("See Less");
    } else {
      setSeeMoreTextTeamBlenders("See More");
    }
    if (seeMoreTeamBlenders === 2) {
      setSeeMoreTeamBlenders(10);
    } else {
      setSeeMoreTeamBlenders(2);
    }
  };

  const onStartActivity = async (activity) => {
    props.setIsLoading(true);
    const game_code = activity?.game_code;
    let gameCodee = game_code;
    console.log(activity, "azscazscazsc");
    if (activity?.editions) {
      console.log("check1===>>>");
      props.setEditions(activity?.editions);
      if (
        activity?.background &&
        activity?.background_mobile &&
        activity?.top_logo &&
        activity?.top_logo_mobile
      ) {
        console.log("check2===>>>");
        console.log(
          activity?.background,
          activity?.background_mobile,
          activity?.top_logo,
          activity?.top_logo_mobile,
          "check3===>>>"
        );
        props.setLTparameters({
          background: activity?.background,
          background_mobile: activity?.background_mobile,
          top_logo: activity?.top_logo,
          top_logo_mobile: activity?.top_logo_mobile
        });
      }
    }

    if (game_code === "WELL") {
      props.setWellnessParamsOnject(activity);
    }
    var cognitoUser = await Auth.userPool.getCurrentUser();

    if (cognitoUser !== null) {
      if (width < 768) {
        props.setGameName(gameCodee);
        props.history.push("/launch_controller");
      } else {
        if (gameCodee === "GAHW") {
          localStorage.setItem("work_game", gameCodee);
          props.setGameName("GAH");
        } else if (gameCodee === "GAHF") {
          localStorage.setItem("work_game", gameCodee);
          props.setGameName("GAH");
        } else if (gameCodee === "CHPTW") {
          localStorage.setItem("work_game", gameCodee);
          props.setGameName("CHPT");
        } else {
          props.setGameName(gameCodee);
          localStorage.removeItem("work_game");
        }
        props.history.push("/lobby");
      }
    } else {
      props.setIsLoading(false);
      sessionStorage.setItem("gameCode", gameCodee);
      props.setGameName(gameCodee);
      props.history.push("/signup");
    }
  };

  const getDataBasedOnActivityType = (browseActivity, activityType) => {
    switch (activityType) {
      case ACTIVITY_TYPES.SQUEEZE:
        return browseActivity.squeezes;
      case ACTIVITY_TYPES.SLICE:
        return browseActivity.slices;
      case ACTIVITY_TYPES.TEAM_BLENDER:
        return browseActivity.team_blenders;
      default:
        return browseActivity;
    }
  };

  const getActivitiesBasedOnCategories = (browseActivity, categories) =>
    categories.length === 0
      ? browseActivity
      : browseActivity?.filter((activity) =>
          activity.categories.some((category) => categories.includes(category))
        );

  const finalData = getDataBasedOnActivityType(browseActivity, activityType);
  let finalActivities = getActivitiesBasedOnCategories(
    finalData?.activities,
    []
  );

  finalActivities = getActivitiesBasedOnCategories(
    finalData?.activities,
    categoryType
  );
  const finalActivitiesSqueezes = getActivitiesBasedOnCategories(
    squeezes?.activities,
    categoryType
  );
  const finalActivitiesSlices = getActivitiesBasedOnCategories(
    slices?.activities,
    categoryType
  );
  const finalActivitiesTeam_blenders = getActivitiesBasedOnCategories(
    team_blenders?.activities,
    categoryType
  );

  const handleSelectActivity = (type) => {
    setActivityType(type);
  };
  const handleSelectCategory = (type) => {
    let temp = [...categoryType];

    if (temp.includes(type)) {
      temp = temp.filter((ele) => {
        return ele != type;
      });
    } else {
      temp.push(type);
    }
    setCategoryType(temp);
  };

  return (
    <div className="team-activities-wrapper">
      <div className="container">
        <p className="outrtxt">Find Team Activities</p>
        <div className="team-activities">
          <div className="ActivityTypeInner">
            <div className="activities-tabs">
              <div
                onClick={() => handleSelectActivity("All Activities")}
                className={cx("activity-tab", {
                  active: activityType === "All Activities"
                })}
              >
                <img src={AllActivity} alt="" />
                <p className="tab-txt">
                  <strong>All Activities</strong>
                </p>
              </div>
              <div
                onClick={() => handleSelectActivity("Squeeze: 3-5 mins")}
                className={cx("activity-tab", {
                  active: activityType === "Squeeze: 3-5 mins"
                })}
              >
                <img src={HalfLemon} alt="" />
                <p className="tab-txt">
                  <strong>Squeeze:</strong> 3-5 mins
                </p>
              </div>
              <div
                onClick={() => handleSelectActivity("Slice: 15-30 mins")}
                className={cx("activity-tab", {
                  active: activityType === "Slice: 15-30 mins"
                })}
              >
                <img src={fullLemon} alt="" />
                <p className="tab-txt">
                  <strong>Slice:</strong> 15-30 mins
                </p>
              </div>
              <div
                onClick={() => handleSelectActivity("Team Blender: +60 mins")}
                className={cx("activity-tab", {
                  active: activityType === "Team Blender: +60 mins"
                })}
              >
                <img src={TeamBlander} alt="" />
                <p className="tab-txt">
                  <strong>Team Blender:</strong> +60mins
                </p>
              </div>
            </div>
            <p className="txt2">Find activities and category:</p>
            <div className="activities-sub-tabs">
              {gameCategories?.map((type, index) => {
                return (
                  <Button
                    key={index}
                    onClick={() => handleSelectCategory(type)}
                    className={cx("catg-btn", {
                      active: categoryType.includes(type)
                    })}
                  >
                    {type}
                  </Button>
                );
              })}
            </div>
            <div className="activities-card-wrapper">
              {activityType === "Squeeze: 3-5 mins" ? (
                <>
                  <Row>
                    <Col xs={12} sm={12} md={7} lg={7}>
                      <div className="activity-text">
                        <div className="activity-flex">
                          <img src={HalfLemon} alt="" />
                          <p className="txt">{squeezes?.label}</p>
                        </div>
                        <p>{squeezes?.text}</p>
                      </div>
                    </Col>
                    {finalActivities?.map((activity, index) => {
                      return (
                        <Col key={index} xs={12} sm={6}>
                          <div className="activities-card">
                            <div className="activities-card-flex">
                              <div className="card-image">
                                <img
                                  className="img-fluid"
                                  src={activity.logo}
                                  alt=""
                                />
                              </div>
                              <div className="card-text">
                                <h4 className="card-title">{activity.label}</h4>
                                <div className="player-info">
                                  <img src={userImg} alt="" />
                                  <p className="txt">{activity.players}</p>
                                </div>
                                <p className="game-info">{activity.text}</p>
                                {activity?.categories?.map(
                                  (category, index) => {
                                    return (
                                      <Button key={index} className="type-btn">
                                        {category}
                                      </Button>
                                    );
                                  }
                                )}
                                {/* <Button className="type-btn">
                                  Cooperative
                                </Button> */}
                              </div>
                            </div>
                            <Button
                              onClick={() => onStartActivity(activity)}
                              className="start-btn"
                            >
                              {activity?.button_text}
                            </Button>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </>
              ) : activityType === "All Activities" ? (
                <>
                  <Row>
                    <Col xs={12} sm={12} md={7} lg={7}>
                      <div className="activity-text">
                        <div className="activity-flex">
                          <img src={HalfLemon} alt="" />
                          <p className="txt">{squeezes.label}</p>
                        </div>
                        <p>{squeezes.text}</p>
                      </div>
                    </Col>
                    {finalActivitiesSqueezes?.map((activity, index) => {
                      if (index < seeMoreSqueezes) {
                        return (
                          <Col key={index} xs={12} sm={6}>
                            <div className="activities-card">
                              <div className="activities-card-flex">
                                <div className="card-image">
                                  <img
                                    className="img-fluid"
                                    src={activity.logo}
                                    alt=""
                                  />
                                </div>
                                <div className="card-text">
                                  <h4 className="card-title">
                                    {activity.label}
                                  </h4>
                                  <div className="player-info">
                                    <img src={userImg} alt="" />
                                    <p className="txt">{activity.players}</p>
                                  </div>
                                  <p className="game-info trun">
                                    {activity.text.length <= 236
                                      ? activity.text
                                      : activity.text.substring(0, 236) + "..."}
                                  </p>
                                  {activity?.categories?.map(
                                    (category, index) => {
                                      return (
                                        <Button
                                          key={index}
                                          className="type-btn"
                                        >
                                          {category}
                                        </Button>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                              <Button
                                onClick={() => onStartActivity(activity)}
                                className="start-btn"
                              >
                                {activity?.button_text}
                              </Button>
                            </div>
                          </Col>
                        );
                      }
                    })}
                    <Button
                      onClick={() => handleSeeMoreSqueezes()}
                      className="see-more-btn"
                    >
                      {seeMoreTextSqueezes}
                    </Button>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {activityType === "Slice: 15-30 mins" ? (
                <>
                  <Row>
                    <Col xs={12} sm={12} md={7} lg={7}>
                      <div className="activity-text">
                        <div className="activity-flex">
                          <img src={HalfLemon} alt="" />
                          <p className="txt">{slices?.label}</p>
                        </div>
                        <p>{slices?.text}</p>
                      </div>
                    </Col>

                    {finalActivities?.map((activity, index) => {
                      return (
                        <Col key={index} xs={12} sm={6}>
                          <div className="activities-card">
                            <div className="activities-card-flex">
                              <div className="card-image">
                                <img
                                  className="img-fluid"
                                  src={activity.logo}
                                  alt=""
                                />
                              </div>
                              <div className="card-text">
                                <h4 className="card-title">{activity.label}</h4>
                                <div className="player-info">
                                  <img src={userImg} alt="" />
                                  <p className="txt">{activity.players}</p>
                                </div>
                                <p className="game-info">{activity.text}</p>
                                {activity?.categories?.map(
                                  (category, index) => {
                                    return (
                                      <Button
                                        key={index}
                                        className="type-btn mr-3"
                                      >
                                        {category}
                                      </Button>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                            <Button
                              onClick={() => onStartActivity(activity)}
                              className="start-btn"
                            >
                              {activity?.button_text}
                            </Button>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </>
              ) : activityType === "All Activities" ? (
                <>
                  <Row>
                    <Col xs={12} sm={12} md={7} lg={7}>
                      <div className="activity-text">
                        <div className="activity-flex">
                          <img src={HalfLemon} alt="" />
                          <p className="txt">{slices.label}</p>
                        </div>
                        <p>{slices.text}</p>
                      </div>
                    </Col>{" "}
                    {finalActivitiesSlices?.map((activity, index) => {
                      if (index < seeMoreSlices) {
                        return (
                          <Col key={index} xs={12} sm={6}>
                            <div className="activities-card">
                              <div className="activities-card-flex">
                                <div className="card-image">
                                  <img
                                    className="img-fluid"
                                    src={activity.logo}
                                    alt=""
                                  />
                                </div>
                                <div className="card-text">
                                  <h4 className="card-title">
                                    {activity.label}
                                  </h4>
                                  <div className="player-info">
                                    <img src={userImg} alt="" />
                                    <p className="txt">{activity.players}</p>
                                  </div>
                                  <p className="game-info">{activity.text}</p>
                                  {activity?.categories?.map(
                                    (category, index) => {
                                      return (
                                        <Button
                                          key={index}
                                          className="type-btn"
                                        >
                                          {category}
                                        </Button>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                              <Button
                                onClick={() => onStartActivity(activity)}
                                className="start-btn"
                              >
                                {activity?.button_text}
                              </Button>
                            </div>
                          </Col>
                        );
                      }
                    })}
                    <Button
                      onClick={() => handleSeeMoreSlices()}
                      className="see-more-btn"
                    >
                      {seeMoreTextSlices}
                    </Button>
                  </Row>
                </>
              ) : (
                <></>
              )}

              {activityType === "Team Blender: +60 mins" ? (
                <>
                  <Row>
                    <Col xs={12} sm={12} md={7} lg={7}>
                      <div className="activity-text">
                        <div className="activity-flex">
                          <img src={HalfLemon} alt="" />
                          <p className="txt">{team_blenders?.label}</p>
                        </div>
                        <p>{team_blenders?.text}</p>
                      </div>
                    </Col>
                    {finalActivities?.map((activity, index) => {
                      return (
                        <Col key={index} xs={12} sm={6}>
                          <div className="activities-card">
                            <div className="activities-card-flex">
                              <div className="card-image">
                                <img
                                  className="img-fluid"
                                  src={activity.logo}
                                  alt=""
                                />
                              </div>
                              <div className="card-text">
                                <h4 className="card-title">{activity.label}</h4>
                                <div className="player-info">
                                  <img src={userImg} alt="" />
                                  <p className="txt">{activity.players}</p>
                                </div>
                                <p className="game-info">{activity.text}</p>
                                {activity?.categories?.map(
                                  (category, index) => {
                                    return (
                                      <Button key={index} className="type-btn">
                                        {category}
                                      </Button>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                            <Button
                              onClick={(e) => handleBlenderClick(e)}
                              className="start-btn"
                            >
                              {activity?.button_text}
                            </Button>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </>
              ) : activityType === "All Activities" ? (
                <>
                  <Row>
                    <Col xs={12} sm={12} md={7} lg={7}>
                      <div className="activity-text">
                        <div className="activity-flex">
                          <img src={HalfLemon} alt="" />
                          <p className="txt">{team_blenders.label}</p>
                        </div>
                        <p>{team_blenders.text}</p>
                      </div>
                    </Col>
                    {finalActivitiesTeam_blenders?.map((activity, index) => {
                      if (index < seeMoreTeamBlenders) {
                        return (
                          <Col key={index} xs={12} sm={6}>
                            <div className="activities-card">
                              <div className="activities-card-flex">
                                <div className="card-image">
                                  <img
                                    className="img-fluid"
                                    src={activity.logo}
                                    alt=""
                                  />
                                </div>
                                <div className="card-text">
                                  <h4 className="card-title">
                                    {activity.label}
                                  </h4>
                                  <div className="player-info">
                                    <img src={userImg} alt="" />
                                    <p className="txt">{activity.players}</p>
                                  </div>
                                  <p className="game-info">{activity.text}</p>
                                  {activity?.categories?.map(
                                    (category, index) => {
                                      return (
                                        <Button
                                          key={index}
                                          className="type-btn"
                                        >
                                          {category}
                                        </Button>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                              <Button
                                onClick={(e) => handleBlenderClick(e)}
                                className="start-btn"
                              >
                                {activity?.button_text}
                              </Button>
                            </div>
                          </Col>
                        );
                      }
                    })}
                    <Button
                      onClick={() => handleSeeMoreTeamBlenders()}
                      className="see-more-btn"
                    >
                      {seeMoreTextTeamBlenders}
                    </Button>
                  </Row>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    setLTparameters: (data) => dispatch(socketAction.setLTparameters(data)),
    setWellnessParamsOnject: (data) =>
      dispatch(gameAction.setWellnessParamsOnject(data)),
    setEditions: (data) => dispatch(socketAction.setEditions(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data))
  };
};

export default compose(withRouter, connect(null, mapDispatchToProps))(TeamAct);
